import Modal from "./modal";
import { $_GET } from "../globalFunctions.js";

export default class TransactionSelectionModal extends Modal {
  constructor() {
    super("transaction-selection-modal");
    this.companyId = window.currentCompany.id;
    this.companyCurrency = window.currentCompany.currency;
    this.isSimulating = false;
    this.requestSent = false;
    this.simulationId = null;
    this.setupListeners();
    this.whenReady();
  }

  whenReady() {
    super.whenReady();

    this.isSimulating =
      this.isInsideASimulation() || location.pathname.includes("/simulations");

    document.querySelectorAll("[data-show-in-simulation]").forEach((el) => {
      if (this.isSimulating) {
        if (
          el.dataset.showInSimulation === true ||
          el.dataset.showInSimulation === "true"
        ) {
          el.parentElement.classList.remove("d-none");
        } else {
          el.parentElement.classList.add("d-none");
        }
      } else {
        if (
          el.dataset.showInSimulation === true ||
          el.dataset.showInSimulation === "true"
        ) {
          el.parentElement.classList.add("d-none");
        } else {
          el.parentElement.classList.remove("d-none");
        }
      }
    });

    if(!this.isSimulating) {
      document.querySelector('[data-id="reverse-stock-split-container"]').classList.remove("d-none");
    }

    if (this.isInsideASimulation()) {
      document
        .querySelectorAll('[data-id="financing-round"]')[1].parentElement
        .classList.remove("d-none");
      document
        .querySelector('[data-id="simulated-financing-round"]').parentElement
        .classList.add("d-none");
    }
  }

  isInsideASimulation() {
    return $_GET("simulation") != null;
  }

  setupListeners() {
    document
      .querySelectorAll('[data-action="show-transaction-modal"]')
      .forEach((el) => {
        el.addEventListener("click", () => {
          if (this.isSimulating && !this.isInsideASimulation()) {
            if (this.simulationId) {
              this.setSimulationUrl(this.simulationId, el.dataset.id);
            } else {
              this.createSimulation(el.dataset.id);
              return;
            }
          }
          this.showModal(el.dataset.id);
        });
      });
  }

  createSimulation(wantedModal) {
    this.requestSent = true;

    peque
      .api(
        "simulations",
        {
          company: window.currentCompany.id,
          type: peque.SIMULATION_TYPE_TRANSACTION,
          name:
            wantedModal.replace("-", " ") +
            " simulation " +
            new Date().toISOString().split("T")[0],
        },
        "post"
      )
      .then((response) => {
        this.setSimulationUrl(response.result.id, wantedModal);

        if (typeof window.pequeData === "undefined") {
          window.pequeData = {};
        }

        window.pequeData.simulation = response.result.id;
        this.requestSent = false;
        this.simulationId = response.result.id;
        this.showModal(wantedModal);
      });
  }

  setSimulationUrl(simulationId, wantedModal) {
    const url = peque.routeFor("transactionsList", {
      simulation: simulationId,
    });
    const modal = this.getModal(wantedModal);
    peque.navigation.fakePush(
      url + "#transaction-selection-modal&" + modal.modalId
    );
  }

  showModal(id) {
    const modal = this.getModal(id);
    modal.$form.reset();
    modal.clearDocuments().show();

    return modal;
  }

  getModal(id) {
    switch (id) {
      case "split":
      case peque.TRANSACTION_TYPE_SPLIT:
        if (typeof peque.splitModal === "undefined") {
          peque.splitModal = new SplitModal(this.companyId, false);
        } else {
          peque.splitModal.setReverse(false);
        }
        return peque.splitModal;
      case "reverse-stock-split":
      case peque.TRANSACTION_TYPE_REVERSE_STOCK_SPLIT:
        if (typeof peque.splitModal === "undefined") {
          peque.splitModal = new SplitModal(this.companyId, true);
        } else {
            peque.splitModal.setReverse(true);
        }
        return peque.splitModal;
      case "document":
        if (typeof peque.uploadDocumentModal === "undefined") {
          peque.uploadDocumentModal = new UploadDocumentModal(this.companyId);
        }
        return peque.uploadDocumentModal;
      case "transfer":
      case peque.TRANSACTION_TYPE_TRANSFER:
        if (typeof peque.transferModal === "undefined") {
          peque.transferModal = new TransferModal(this.companyId);
        }
        return peque.transferModal;
      case "payout":
      case peque.TRANSACTION_TYPE_PAYOUT:
        if (typeof peque.payoutModal === "undefined") {
          peque.payoutModal = new PayoutModal(this.companyId);
        }
        return peque.payoutModal;
      case "convert-loan":
        if (typeof peque.convertLoanModal === "undefined") {
          peque.convertLoanModal = new ConvertLoanModal(this.companyId);
        }
        return peque.convertLoanModal;
      case "valuation":
      case peque.TRANSACTION_TYPE_VALUATION:
        if (typeof peque.valuationModal === "undefined") {
          peque.valuationModal = new ValuationModal(this.companyId);
        }
        return peque.valuationModal;
      case "issue":
      case peque.TRANSACTION_TYPE_ISSUE:
        if (typeof peque.issueModal === "undefined") {
          peque.issueModal = new IssueModal(this.companyId);
        }
        return peque.issueModal;
      case "decrease-shares":
      case peque.TRANSACTION_TYPE_DECREASE_SHARES:
        if (typeof peque.decreaseSharesModal === "undefined") {
          peque.decreaseSharesModal = new DecreaseSharesModal(this.companyId);
        }
        return peque.decreaseSharesModal;
      case "financing-round":
      case peque.TRANSACTION_TYPE_FINANCING_ROUND:
        if (typeof peque.financingRoundModal === "undefined") {
          peque.financingRoundModal = new FinancingRoundModal(
            this.companyId,
            this.companyCurrency
          );
        }
        return peque.financingRoundModal;
      case "convertible-loan":
      case peque.TRANSACTION_TYPE_CONVERTIBLE_LOAN:
        if (typeof peque.convertibleLoanModal === "undefined") {
          peque.convertibleLoanModal = new ConvertibleLoanModal(this.companyId);
        }
        return peque.convertibleLoanModal;
      case "add-pool":
      case peque.TRANSACTION_TYPE_POOL_CREATION:
        if (typeof peque.addPoolModal === "undefined") {
          peque.addPoolModal = new AddPoolModal(this.companyId);
        }
        return peque.addPoolModal;
      case "increase-pool":
      case peque.TRANSACTION_TYPE_POOL_INCREASE:
        if (typeof peque.increasePoolModal === "undefined") {
          peque.increasePoolModal = new IncreasePoolModal(this.companyId);
        }
        return peque.increasePoolModal;
      case "decrease-pool":
      case peque.TRANSACTION_TYPE_POOL_DECREASE:
        if (typeof peque.decreasePoolModal === "undefined") {
          peque.decreasePoolModal = new DecreasePoolModal(this.companyId);
        }
        return peque.decreasePoolModal;
      case "add-plan":
      case peque.TRANSACTION_TYPE_PLAN_CREATION:
        if (typeof peque.addPlanModal === "undefined") {
          peque.addPlanModal = new AddPlanModal(this.companyId);
        }
        return peque.addPlanModal;
      case "single-grant":
      case peque.TRANSACTION_TYPE_GRANT:
        if (typeof peque.singleGrantModal === "undefined") {
          peque.singleGrantModal = new SingleGrantModal(this.companyId);
        }
        return peque.singleGrantModal;
      case "convert-all-loans":
        if (typeof peque.convertAllConvertiblesModal === "undefined") {
          peque.convertAllConvertiblesModal = new ConvertAllConvertiblesModal();
        }
        return peque.convertAllConvertiblesModal;
    }
  }

  wantsToSimulate() {
    this.isSimulating = true;
  }
}
